import React, {useEffect, useState} from 'react'
import {H1, HelperText, InfoAlert} from '@worthy-npm/clarity'
import I18n from "lib/i18n/i18n"
import WorthyApi from "lib/api/worthyApi";
import {Grid} from "@material-ui/core";
import {imageUrl, isMobile} from "../../helpers/ApplicationHelper";
import ItemLinkSticky from "../item/itemLinkSticky";
import Trustpilot from "../trustpilot";
import RecentDeals from "../recentDeals";
import UserActions from "lib/userActions";

const LightTrends =  (props) => {

    const version = I18n.getString('itemPage::lightTrends::version')
    const {itemId} = props.params
    const [totalPrice, setTotalPrice] = useState('$')
    const [diamondPrice, setDiamondPrice] = useState('$')
    const [metalPrice, setMetalPrice] = useState('$')
    const [itemDesc, setItemDesc] = useState('')
    const [similarItems, setSimilarItems] = useState([])

    useEffect(() => {
        UserActions.lightTrendsPage('Light Trends page presented', itemId, version)
        WorthyApi.getListingTrendsAndLog(itemId, true)
            .then((res) => {
                setRangeValues(res.data)
            })
    }, []);


    const setRangeValues = (trends) => {
        const estimations = trends.subset_values
        const diamondRange = trends.est_range
        const sumSubsets = Object.keys(estimations).filter(k => k != "Center Stone").reduce((total, obj) => estimations[obj] + total, 0)
        const diamondLow = Math.round((diamondRange.low - sumSubsets))
        const diamondHigh = Math.round((diamondRange.high - sumSubsets))
        const metalLow = Math.round(estimations['Ring'] +
            (estimations["Side Stone Batch"]? estimations["Side Stone Batch"]: 0) +
            (estimations["Minor Stone Batch"]? estimations["Minor Stone Batch"]: 0))
        const metalHigh = Math.round(metalLow * 1.2)

        setTotalPrice(`$${(diamondLow + metalLow).toLocaleString('en')} - $${(diamondHigh + metalHigh).toLocaleString('en')}`)
        setDiamondPrice(`$${diamondLow.toLocaleString('en')} - $${diamondHigh.toLocaleString('en')}`)
        setMetalPrice(`$${metalLow.toLocaleString('en')} - $${metalHigh.toLocaleString('en')}`)

        setItemDesc(trends.desc)
        setSimilarItems(trends.similar_sold_items || [])
    }

    const dataContainer = () => {
        return (
            <>
                <div className={'slider-wrapper'}>
                        <Grid container className={'values-range'} >
                            <ValueRange prop={'total'} value={totalPrice} size={'medium'}/>
                            <ValueRange prop={'diamond'} value={diamondPrice} caratWeight={itemDesc.split(' ')[0]} size={'medium'}/>
                            <ValueRange prop={'metal'} value={metalPrice}  size={'medium'} />
                            <ValueRange prop={'static'} value={I18n.getString('itemPage::lightTrends::valueRange::staticValue')} size={'small'} />
                        </Grid>

                </div>
                <InfoAlert text={I18n.getString('itemPage::lightTrends::notification')} canClose={false}  />
            </>
        )
    }


    return (
        <div>
            <ItemLinkSticky text={itemDesc} itemId={itemId} version={version} />
            <div className={'light-trends'}>
                <H1 text={I18n.getString('itemPage::lightTrends::title')}/>
                <div className={'helper-text'} >{I18n.getString('itemPage::lightTrends::helperText')} </div>
                {
                    isMobile() ? (
                        <>
                            {dataContainer()}
                            <Grid container >
                                <SellYourRingSection />
                            </Grid>
                        </>)
                        : (
                            <Grid container spacing={16}>
                                <Grid item xs={8}>
                                    {dataContainer()}
                                </Grid>
                                <Grid item xs={4}>
                                    <SellYourRingSection />
                                </Grid>
                            </Grid>
                        )
                }
            </div>
            { similarItems && similarItems.length > 3 ? <SimilarSoldItemsSection similarItems={similarItems} itemId={itemId} version={version} /> : null}
        </div>
    )

}

export default LightTrends


const ValueRange = (props) => {
    const {prop, value, caratWeight, size} = props

    return (
        <Grid item xs={size === 'big' ? 4 : (size === 'small' ?  2 : 3 )} className={`${prop}-range`}>
            <img  src={imageUrl(`item/lightTrends/${prop}.svg`)} />
            <div className={`range-price ${prop}`}>{value}</div>
            <div className={`range-desc ${prop}`}>{I18n.getString(`itemPage::lightTrends::valueRange::${prop}`, {caratWeight})}</div>
        </Grid>
    )
}


const SellYourRingSection = () => {
    const tips = [];

    for (let i = 1; i < 4; i++) {
        tips.push(
            <div key={i} className={'tip'}>
                <img src={imageUrl('item/lightTrends/check.svg')}/>
                <span>{I18n.getString(`itemPage::lightTrends::sellSection::bullet${i}`)}</span>
            </div>
        )
    }

    return (
        <div className={'sell-your-ring'}>
            <div className={'title'}>{I18n.getString('itemPage::lightTrends::sellSection::title')}</div>
            { tips }
            <Trustpilot templateId={'5419b732fbfb950b10de65e5'}/>
        </div>
    )
}

const SimilarSoldItemsSection = (props) => {
    const {similarItems, itemId, version} = props

    return (
        <Grid container className='similar-items-full-width'>
            <div className={'similar-items'}>
            <div className={'similar-title'}>{I18n.getString(`itemPage::lightTrends::similarItemsTitle`)}</div>
                <RecentDeals deals={similarItems} itemId={itemId} version={version}/>
            </div>
        </Grid>
    )
}

